import { UserOutlined } from '@ant-design/icons';
import { Avatar, Skeleton, Space, Tooltip, Typography } from 'antd';
import { DateTime } from 'luxon';
import React, { memo, Suspense, useEffect, useState } from 'react';
import { useLazyLoadQuery } from 'react-relay';

import { ActivityLogsQuery as ActivityLogsQueryType } from '../../graphql/__generated__/ActivityLogsQuery.graphql';
import { ActivityLogsQuery } from '../../graphql/ActivityLogsQuery';
import { ActivityLogType } from '../../types';

const Text = Typography.Text;

interface IActivityLogsTable {
    model_id: string;
    fetchKey?: number;
    isDragging?: boolean;
    maxHeight?: string;
}

const ActivityLogsTable: React.FC<IActivityLogsTable> = memo(({ model_id, fetchKey, isDragging, ...props }) => {
    const [localFetchKey, setLocalFetchKey] = useState<number>();
    const maxHeight = props.maxHeight || '200px';

    useEffect(() => {
        setLocalFetchKey(fetchKey);
    }, [fetchKey]);

    const queryData = useLazyLoadQuery<ActivityLogsQueryType>(
        ActivityLogsQuery,
        {
            id: model_id,
            order_by: ['created_at:DESC'],
        },
        {
            fetchPolicy: localFetchKey === fetchKey ? 'store-only' : 'network-only',
            fetchKey: `${model_id}_${fetchKey}`,
        },
    );
    const activities = queryData.activityLogs?.edges?.map((edge) => edge?.node) as any as ActivityLogType[];

    const renderItemActivity = (activity: ActivityLogType) => {
        const date = new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }).format(new Date(activity.created_at + 'Z'));

        return (
            <Space key={activity.id} direction="vertical" size={0} style={{ width: '100%' }}>
                <Space align="start">
                    {/* {activity.causer.avatar ? (
                            <Avatar src={activity.causer.avatar} alt={activity.causer.name} />
                        ) : ( */}
                    {activity.causer && <Avatar icon={<UserOutlined />} alt={activity.causer.name} />}
                    {/* )} */}
                    <Space direction="vertical" size={0}>
                        <Space direction="horizontal" size={10}>
                            <Text strong>{activity.causer ? activity.causer.name : 'SiteMax User'}</Text>
                            <Tooltip
                                title={date}
                            >
                                <Text type="secondary" style={{ fontSize: '12px' }}>
                                    {DateTime.fromSQL(activity.created_at + 'Z').toRelative()}
                                </Text>
                            </Tooltip>
                        </Space>
                        <Text style={{ marginLeft: 0 }}>{activity.description}</Text>
                    </Space>
                </Space>
            </Space>
        );
    };

    return (
        <div
            style={{
                maxHeight,
                overflow: 'auto',
            }}
        >
            {!isDragging ? activities?.map(renderItemActivity) || null : <Skeleton active />}
        </div>
    );
});

export default function ActivityLogsFeed(props: IActivityLogsTable) {
    return (
        <Suspense fallback={<Skeleton active />}>
            <ActivityLogsTable {...props} />
        </Suspense>
    );
}
